import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { parseRequestType } from 'api/getRequestType';

const query = gql`
query RequestTypesPagination($onlyActive: Boolean, $page: Int, $pageSize: Int) {
  allRequestTypesPagination(onlyActive: $onlyActive, page: $page, pageSize: $pageSize) {
    requestTypes {
      id
      name
      description
      defaultType
      active
      system
      keywords {
        token
      }
      removable
      teams {
        id
        name
      }
      allTeamsOn
    }
    totalCount
    pageSize
  }
}`;

function getAllRequestTypesPagination(page, pageSize, onlyActive = false) {
  return apollo.client.query({
    query,
    variables: {
      onlyActive,
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => ({
    totalCount: res.data.allRequestTypesPagination.totalCount,
    requestTypes: res.data.allRequestTypesPagination.requestTypes
      .map((item) => parseRequestType(item)),
    pageSize: res.data.allRequestTypesPagination.pageSize,
  }));
}

export default getAllRequestTypesPagination;
